/**
 * Shared Photo Upload Utility
 * Provides XHR-based photo uploads with progress tracking for Alpine.js components
 *
 * Re-exports core functionality from photo-upload-core.js and adds Alpine-specific helpers
 */

// Re-export core functionality
export {
    PHOTO_UPLOAD_ENDPOINT,
    PhotoUploadConfig,
    PhotoUploadErrors,
    validateFile,
    parsePhotoResponse,
    parseServerError,
    uploadPhoto,
    deletePhoto
} from './photo-upload-core.js';

/**
 * Parse upload error into user-friendly message
 * @param {Error} error - Error object
 * @returns {string} User-friendly error message
 */
export function parseUploadError(error) {
    if (!error) return 'Upload failed';

    if (error.name === 'AbortError' || error.message === 'Upload cancelled') {
        return 'Upload cancelled';
    }

    if (error instanceof TypeError) {
        return 'Network error';
    }

    const message = error.message || '';

    if (message.includes('413')) return 'File too large';
    if (message.includes('415')) return 'Invalid format';
    if (message.includes('401') || message.includes('403')) return 'Not authorized';
    if (message.includes('500') || message.includes('502') || message.includes('503')) return 'Server error';

    return error.message || 'Upload failed';
}

/**
 * Create a photo slot state object (for getting-started style fixed slots)
 * @returns {Object} Empty photo slot state
 */
export function createEmptySlot() {
    return {
        file: null,
        preview: null,
        uploading: false,
        uploaded: false,
        progress: 0,
        error: null,
        photoId: null
    };
}

/**
 * Create a photo object for dynamic arrays (for post composer style)
 * @param {File} file - File object
 * @param {string} dataUrl - Data URL preview
 * @returns {Object} Photo object
 */
export function createPhotoObject(file, dataUrl) {
    return {
        file,
        dataUrl,
        id: Date.now() + Math.random(),
        uploading: true,
        uploadedPhotoId: null,
        thumbnailUrl: null,
        progress: 0,
        error: null
    };
}
